<template>
	<div v-if="playlist_url">
		<v-layout row>
			<v-flex xs12>
				<video-player
					v-if="playlist_url"
					ref="player"
					style="width: 100%;"
					:position="player_position"
					v-on:loaded="player_loaded"
					:url="playlist_url"
					v-on:position-duration="position_duration">
				</video-player>

				<div v-if="!playlist_url">Cannot load video</div>
			</v-flex>
		</v-layout>
		<v-layout row>
			<v-flex xs12>
  			<v-btn fab small color="deep-orange" flat v-on:click="refresh_video" dark><v-icon>refresh</v-icon></v-btn>
				<v-btn style="width: 120px;" small color="success" :disabled="is_slider" v-on:click="set_in_position">In ({{format_time(in_position)}})</v-btn>
				<v-btn style="width: 120px;" small color="success" :disabled="is_slider" v-on:click="set_out_position">Out - ({{format_time(out_position)}})</v-btn>
				<v-btn small color="success" :disabled="is_slider" v-on:click="seek_to_in_position">Seek to IN</v-btn>
				<v-btn small color="success" :disabled="is_slider" v-on:click="seek_to_out_position">Seek to Out</v-btn>
				<v-btn small color="success" :disabled="is_slider" v-on:click="play_clip"><v-icon>play_arrow</v-icon> Play clip</v-btn>

				<v-menu offset-y :close-on-content-click="false" :nudge-width="150" v-model="save_dialog" v-if="!use_save_dialog">
					<v-btn small color="deep-orange" dark slot="activator">Save</v-btn>

        	<v-card style="min-width: 350px; max-width: 350px;" v-if="save_dialog">
        		<clip-editor ref="clip_editor" :event-uuid="uuid" :in-position="in_position" :out-position="out_position" v-on:save="create_clip"></clip-editor>
        	</v-card>
      	</v-menu>

      	<v-dialog width="400" v-model="save_dialog" v-if="use_save_dialog">
	      	<v-btn v-if="use_save_dialog" small color="deep-orange" dark slot="activator">Save</v-btn>
	      	<v-card v-if="save_dialog">
        		<clip-editor ref="clip_editor" :event-uuid="uuid" :in-position="in_position" :out-position="out_position" v-on:save="create_clip"></clip-editor>
        	</v-card>
	      </v-dialog>

				<v-menu offset-y :close-on-content-click="false" :nudge-width="150" v-model="tag_dialog" v-if="!use_save_dialog">
					<v-btn small color="success" dark slot="activator">Add tag</v-btn>

					<v-card style="min-width: 350px; max-width: 350px; padding: 10px;" v-if="tag_dialog">
						<tag-editor :event_uuid="uuid" :position="position" v-on:save="tag_dialog=false"></tag-editor>
        	</v-card>
				</v-menu>

				<v-dialog width="800" v-model="export_dialog" v-if="mtv_special_visible">
					<template v-slot:activator="{ on }">
						<v-btn small color="success" dark v-on="on" >MTV compilation export</v-btn>
					</template>
					<v-card>
						<export-mtv-special-editor v-model="export_dialog" :event_uuid="uuid" v-if="export_dialog"></export-mtv-special-editor>
					</v-card>
				</v-dialog>

			</v-flex>
		</v-layout>


		<v-layout row>
			<v-flex xs12>
				<vue-slider
					class="ml-4 mr-4"
					v-if="!is_slider"
					:min="0" :max="duration" :speed="0" :value="slider_value" tooltip-dir="bottom" v-on:callback="change_slider_position" :process-dragable="false"
					:slider-style="{'border-radius': '0px'}"
					:dot-width="5" :dot-height="20" :formatter="tooltip_formatter">
				</vue-slider>


			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import VideoPlayer from './VideoPlayerClappr.vue';
import vueSlider from 'vue-slider-component';
import ClipEditor from './Clip.vue';
import ExportMtvSpecialEditor from './ExportMtvSpecial.vue';
import TagEditor from '../events/tags/Editor.vue';


export default {
	props: ["uuid", "new-in-position", "new-out-position", "new-positions", "use-save-dialog", "disable-key-events"],
	components: {
		VideoPlayer,
		vueSlider,
		ClipEditor,
		TagEditor,
		ExportMtvSpecialEditor
	},
	data () {
		var config_ch = this.$cloudserver.channel("events:clip_settings:"+this.uuid);
		return {
			ws_channel: config_ch,
			playlist_url: undefined,
			position: undefined,
			duration: undefined,
			in_position: undefined,
			out_position: undefined,
			player_position: undefined,
			slider_value: [0,0],
			playlist_url_tmp: undefined,
			position_tmp: undefined,
			save_dialog: false,
			tag_dialog: false,
			export_dialog: false,
			info: {
				title: "",
				description: "",
				tags: ""
			}
		}
	},
	watch: {
		"newInPosition": function(newVal) {
			if (newVal < 0) newVal = 0;
			this.change_in_position(newVal);
			this.seek_to_in_position();
		},
		"newOutPosition": function(newVal) {
			if (newVal < 0) newVal = 0;
			this.change_out_position(newVal);
		},
		"newPositions": function(newVal) {
			var in_pos = newVal[0];
			var out_pos = newVal[1];
			if (in_pos < 0) in_pos = 0;
			if (out_pos < 0) out_pos = 0;
			if (in_pos > this.duration || out_pos > this.duration) {
				this.$nextTick(function() {
					this.refresh_video();
					this.change_in_position(in_pos);
					this.seek_to_in_position();
					this.change_out_position(out_pos);
				});
			} else {
				this.change_in_position(in_pos);
				this.seek_to_in_position();
				this.change_out_position(out_pos);
			}
		},
		"ws_channel.data": {
			handler(newVal, oldVal) {
				this.playlist_url = newVal.preview_playlist_url;
				this.playlist_url_tmp = newVal.preview_playlist_url;
			},
			deep: true
		},
		"save_dialog": function(newVal) {
			if (newVal == true) {

			}
		}

	},
	mounted () {
		var in_pos = this.newPositions[0];
		var out_pos = this.newPositions[1];
		if (typeof(in_pos) != "undefined" && typeof(out_pos) != "undefined") {
			this.change_in_position(in_pos);
			this.seek_to_in_position();
			this.change_out_position(out_pos);
		}
	},
	created () {
		var self = this;
		this.ws_channel.join();

		window.addEventListener('keydown', this.keyDown);

	},
	methods: {
		format_time (time, paddedHours) {
		  time = time * 1000
  		time = parseInt(time/1000)
  		const seconds = time % 60
  		time = parseInt(time/60)
  		const minutes = time % 60
  		time = parseInt(time/60)
  		const hours = time % 24
  		const days = parseInt(time/24)
  		let out = ''
  		if (days && days > 0) {
    		out += days + ':'
    		if (hours < 1) out += '00:'
  		}
  		if (hours && hours > 0 || paddedHours) out += ('0' + hours).slice(-2) + ':'
  		out += ('0' + minutes).slice(-2) + ':'
  		out += ('0' + seconds).slice(-2)
  		return out.trim()
		},
		tooltip_formatter(v, a) {
			return this.format_time(v);
		},
		play_clip () {
			this.$refs.player.play_clip(this.in_position, this.out_position);
		},

		position_duration(value) {
			this.position = value.position;
			this.duration = value.duration;
		},


		create_clip() {
			var data = {duration: this.duration, position: this.position, in_position: this.in_position, out_position: this.out_position, info: this.info};
			this.$emit("clip", data);
			this.save_dialog = false;
		},
		refresh_video (cb) {
			this.playlist_url = "";
			this.position_tmp = this.position;
			this.position = undefined;
			this.duration = undefined;
			this.$nextTick(function () {
				this.playlist_url = this.playlist_url_tmp;
				if (typeof(cb) == "function") {
					cb();
				}
			});
		},
		change_slider_position (new_value) {
			var seek_marker = 0;
			if (this.out_position != new_value[1]) seek_marker = 1;
			if (this.in_position != new_value[0]) seek_marker = 0;

			this.in_position = new_value[0];
			this.out_position = new_value[1];

			this.seek(new_value[seek_marker]);
		},


		update_slider () {
			this.slider_value = [this.in_position, this.out_position];
		},
		set_in_position () {
			this.in_position = this.position;
			this.update_slider();
		},
		set_out_position () {
			this.out_position = this.position;
			this.update_slider();
		},
		change_out_position(value) {
			this.out_position = value;
			this.update_slider();
		},
		change_in_position(value) {
			this.in_position = value;
			this.update_slider();
		},
		seek (position) {
			this.player_position = -1;
			this.$nextTick(function() {
				this.player_position = position;
			});
		},
		step (change) {
			this.seek(this.position + change);
		},
		seek_to_in_position () {
			this.seek(this.in_position);
		},
		seek_to_out_position () {
			this.seek(this.out_position);
		},
		player_loaded() {
			if (typeof(this.out_position) == "undefined") this.out_position = this.duration;
			if (typeof(this.in_position) == "undefined") this.in_position = 0;
			if (typeof(this.position_tmp) != "undefined") {
				this.seek(this.position_tmp);
			} else {
				this.seek_to_in_position();
			}
			this.update_slider();
		},
		keyDown(event) {
			if (event.keyCode == 83 && event.altKey && this.save_dialog) {
				 // S
				 event.preventDefault();
				this.$refs.clip_editor.save()
			}
			if(this.is_key_events_disabled) return;
 			if (event.keyCode == 37) {
 				var val = -1
 				if (event.altKey) val = -5;
 				if (event.shiftKey) val = -10;
 				this.step(val);
 			}
 			if (event.keyCode == 39) {
 				var val = +1;
 				if (event.altKey) val = +5;
 				if (event.shiftKey) val = +10;
 				this.step(val);
 			}
 			if (event.keyCode == 81 && event.altKey) {
 				if (event.shiftKey) {
 					this.seek_to_in_position();
 				} else {
	 				this.set_in_position();
	 			}
 			}
 			if (event.keyCode == 87 && event.altKey) {
 				if (event.shiftKey) {
 					this.seek_to_out_position();
 				} else {
	 				this.set_out_position();
	 			}
 			}
 			if (event.keyCode == 82 && event.altKey) {
				// R
 				this.refresh_video()
 			}
 			if (event.keyCode == 32 ) {
				 // Space
				event.preventDefault()
				this.$refs.player.toggle()
 			}
    }
	},
	computed: {
		mtv_special_visible() {
			return _.get(this.$store.state.account, "meta.mtv_special_import", false);
		},
		is_key_events_disabled() {
			return this.disableKeyEvents || this.tag_dialog || this.save_dialog;
		},
		use_save_dialog () {
			if (this.useSaveDialog != true) return false;
			return true;
		},
		is_slider () {
			return (typeof(this.duration) == "undefined");
		},
	},
	destroyed() {
		window.removeEventListener('keydown', this.keyDown)
	}

}
</script>